import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export const getContainerTypeAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetContainerType`,
  });
};

export type ContainerTypeResponse = {
  codeId: string;
  codeDesc: string;
  value1: null;
  value2: null;
  value3: null;
  string1: null;
  string2: null;
  string3: null;
}[];

export const fetchContainerType = async (): Promise<ContainerTypeResponse> => {
  const response: AxiosResponse<ContainerTypeResponse> = await getContainerTypeAPI();
  return response.data;
};
